document.addEventListener('DOMContentLoaded', () => {
  const gate = document.querySelector('[data-age-gate]');
  const verifiedKey = 'ie_age_verified';

  const closeGate = () => {
    if (!gate) return;
    gate.classList.remove('active');
    gate.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('age-gate-open');
    document.body.classList.remove('age-gate-open');
  };

  const openGate = () => {
    if (!gate) return;
    gate.classList.add('active');
    gate.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('age-gate-open');
    document.body.classList.add('age-gate-open');
    window.requestAnimationFrame(() => gate.querySelector('[data-age-yes]')?.focus({preventScroll:true}));
  };

  if (gate && localStorage.getItem(verifiedKey) !== '1') openGate();

  gate?.querySelector('[data-age-yes]')?.addEventListener('click', () => {
    try { localStorage.setItem(verifiedKey, '1'); } catch (e) {}
    closeGate();
  });

  gate?.querySelector('[data-age-no]')?.addEventListener('click', () => {
    window.location.assign('https://www.google.com/');
  });

  document.querySelector('[data-mobile-toggle]')?.addEventListener('click', () => {
    document.body.classList.toggle('menu-open');
  });
});
